<div *ngIf="!filters || filters.length==0" class="text-left">
    <ng-container *ngIf="dossierPhases && dossierPhases.length>0">            
        <button type="button" title="Aggiungi criterio" class="btn btn-outline-success btn-sm mr-2" 
                [disabled]="!dossierPhases || dossierPhases.length==0" 
                (click)="addFilter()">
                <i class="fa fa-plus"></i></button>
        <i class="text-xs">Aggiungi un criterio di ricerca avanzata</i>
    </ng-container>
    <div class="p-1" *ngIf="!dossierPhases || dossierPhases.length==0">
        <i class="fa fa-info-circle text-primary mr-2"></i>
        <i class="text-xs">Non sono stati definiti campi personalizzati!</i> 
    </div>
</div>

<div *ngIf="filters && filters.length>0" class="m-1">
    <div class="input-group input-group-sm mb-0 w-100" *ngFor="let f of filters;index as i">
        <div class="input-group-prepend input-group-prepend-sm">
            <button type="button" title="Elimina regola" class="btn btn-sm btn-danger" (click)="removeFilter(f)"><i class="fa fa-minus"></i></button>
        </div>
        <div class="input-group-prepend input-group-prepend-sm" style="max-width:20vw">
            
            <select name="customfield" class="form-control form-control-sm" [(ngModel)]="f.field">
                <ng-container *ngFor="let p of dossierPhases">
                    <optgroup *ngFor="let section of p.sections"
                              label="{{p.title}} - {{section.label?section.label:section.name}}">
                        <ng-container *ngFor="let field of section.fields">
                            <option *ngIf="field.type=='separator'" disabled>
                                {{field.label?field.label:field.name}}
                            </option>
                            <option *ngIf="field.type!='separator'" [ngValue]="field">
                                {{field.label?field.label:field.name}}
                            </option>
                        </ng-container>
                    </optgroup>
                </ng-container>
            </select>
        </div>
        <div class="input-group-prepend input-group-prepend-sm" *ngIf="f.field" style="max-width:15vw">                            
            <select name="condition" class="form-control form-control-sm" [(ngModel)]="f.condition">
                <option value="ugual">uguale a</option>
                <option value="major">maggiore di</option>
                <option value="majorugual">maggiore o uguale a</option>
                <option value="minor">minore di</option>
                <option value="minorugual">minore o uguale</option>
                <option value="like">contiene</option>
                <option value="notlike">non contiene</option>
                <option value="null">non è valorizzato</option>
                <option value="notnull">è valorizzato</option>
            </select>
        </div>
        <div class="input-group-prepend input-group-prepend-sm" *ngIf="f.field" style="max-width:20vw">
            <input *ngIf="f.field.type=='text' || f.field.type=='multi' || f.field.type=='tax_code'" type="text" name="value" class="form-control form-control-sm" [(ngModel)]="f.value" />
            <input *ngIf="f.field.type=='date'" type="date" name="value" class="form-control form-control-sm" [(ngModel)]="f.value" />
            <input *ngIf="f.field.type=='url'" type="url" name="value" class="form-control form-control-sm" [(ngModel)]="f.value" />
            <select *ngIf="f.field.type=='checkbox'" name="value" class="form-control form-control-sm" [(ngModel)]="f.value">
                <option value="1">Si</option>    
                <option value="0">No</option>
            </select>
            <input *ngIf="f.field.type=='number'" type="number" name="value" class="form-control form-control-sm" [(ngModel)]="f.value" />
            <div class="input-group input-group-sm" *ngIf="f.field.type=='currency'" >                
                <input type="number" class="form-control form-control-sm"  min="0" step="0.01" name="value" placeholder="" [(ngModel)]="f.value" >
                <div class="input-group-append input-group-append-sm">
                    <span class="input-group-text">Euro</span>
                </div>
            </div>
            <div *ngIf="f.field.type=='select'">
                <select class="form-control form-control-sm" name="value" [(ngModel)]="f.value">
                    <optgroup *ngIf="f.field.params!=null && f.field.params!=''">
                        <option  *ngFor="let o of f.field.params" value="{{o}}">{{o}}</option>
                    </optgroup>
                </select>
            </div>
        </div>
        <div class="input-group-append input-group-append-sm" *ngIf="f.field && i==filters.length-1">
            <button type="button" title="Aggiungi criterio" class="btn btn-success btn-sm" 
                [disabled]="!dossierPhases || dossierPhases.length==0" 
                (click)="addFilter()">
                <i class="fa fa-plus"></i></button>
        </div>
    </div>
</div>

